
import Spinner from "react-bootstrap/Spinner";

const Loading = ({height = "min-vh-100"}) => (
    <div className={`d-flex align-items-center justify-content-center ${height}`}>
        <Spinner animation="border" />{" "}
    </div>
)

export default Loading;